import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    marginBottom: '0px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },

  root: {
    marginBottom: 16
  },

  returnIcon: {
    paddingRight: 16
  },
  spacer: {
    display: 'none',
    [theme.breakpoints.down('lg')]: { flex: 1, display: 'block' }
  },
  titleRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },

  title: {
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  reset: {
    fontSize: theme.size.base,
    textAlign: 'right',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginLeft: 'auto'
  },

  sections: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px'
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',

    '&:last-child': {
      marginBottom: '0'
    }
  },

  sectionTitle: {
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  sectionContent: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },

  item: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    padding: '6px 10px',
    background: 'white',
    color: '#1F1F1F',
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: theme.size.base
  },

  itemSelected: {
    background: '#F8D8FF',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px'
  },

  button: {
    marginBottom: '8px',
    borderRadius: '8px',
    width: '100%',
    fontSize: theme.size.base,

    '&:last-child': {
      marginBottom: '0'
    }
  },

  buttonInvert: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    background: 'white',

    '&:hover': {
      background: '#F8D8FF'
    }
  }
}))

export default useStyles
